module.exports = __webpack_public_path__ + "img/bindMobile.cb2ba37e.png";